import React from "react";
import type { IColumn } from "@fluentui/react";
import type { UUID } from "../../utils/uuid";
import { observer } from "mobx-react";
import { computed, makeObservable } from "mobx";
import type { EloshieldClassicStationaryModule } from "../../api";

interface ListEloshieldClassicStationaryModuleItemCellProps {
    readonly eloshieldClassicStationaryModuleId: UUID;
    readonly column: IColumn;
}
import { store } from "../../store";

@observer
export class ListEloshieldClassicStationaryModuleItemCell extends React.Component<ListEloshieldClassicStationaryModuleItemCellProps> {
    constructor(props: ListEloshieldClassicStationaryModuleItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get eloshieldClassicStationaryModule():
        | EloshieldClassicStationaryModule
        | undefined {
        return store.repositoryEloshieldClassicStationaryModules.byId(
            this.props.eloshieldClassicStationaryModuleId,
        );
    }

    public render(): JSX.Element {
        const { column } = this.props;
        if (!this.eloshieldClassicStationaryModule) {
            return <></>;
        }
        switch (column.key) {
            case "serialNumber":
                return <span>{this.eloshieldClassicStationaryModule.serialNumber}</span>;
            case "label":
                return <span>{this.eloshieldClassicStationaryModule.label}</span>;
            case "machineId":
                return <span>{this.eloshieldClassicStationaryModule.machineId}</span>;
            case "antennaANetworkIds":
                return (
                    <span>
                        {this.eloshieldClassicStationaryModule.antennaANetworkIds.join(", ")}
                    </span>
                );
            case "antennaBNetworkIds":
                return (
                    <span>
                        {this.eloshieldClassicStationaryModule.antennaBNetworkIds.join(", ")}
                    </span>
                );
            default:
                return <></>;
        }
    }
}
